import { render, staticRenderFns } from "./LowAgeConfirmModal.vue?vue&type=template&id=d818d0f8&scoped=true"
import script from "./LowAgeConfirmModal.vue?vue&type=script&lang=js"
export * from "./LowAgeConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./LowAgeConfirmModal.vue?vue&type=style&index=0&id=d818d0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d818d0f8",
  null
  
)

export default component.exports